(function() {
  // バリエーションが切り替わった時に動く命令
  document.addEventListener('theme:variant:change', function(event) {
    var variant = event.detail.variant;
    var container = event.target;
    
    // 価格が表示されている場所（Pipeline標準のクラス名）を探す
    var priceElement = document.querySelector('.product__price');

    if (variant) {
      if (!variant.available) {
        // --- 在庫がないバリエーションを選んだ場合 ---
        if (priceElement) {
          // 元の価格をデータ属性に保存（在庫ありに戻った時のため）
          if (!priceElement.getAttribute('data-base-price')) {
            priceElement.setAttribute('data-base-price', priceElement.innerHTML);
          }
          // 表示を「SOLD OUT」に変更
          priceElement.innerHTML = '<span style="color: #ff0000; font-weight: bold;">SOLD OUT</span>';
        }
      } else {
        // --- 在庫があるバリエーションを選んだ場合 ---
        if (priceElement && priceElement.getAttribute('data-base-price')) {
          // 保存しておいた元の価格表示（数字）に戻す
          priceElement.innerHTML = priceElement.getAttribute('data-base-price');
          // Pipeline本体のスクリプトが価格を最新に更新するのを待つため、ここではリセットのみ
        }
      }
    }
  });

  // セレクトボックスを強制的に有効化する処理（ページ読み込み時）
  function enableSoldOutOptions() {
    var selects = document.querySelectorAll('select.product__form__select, select[data-variant-input]');
    selects.forEach(function(select) {
      var options = select.querySelectorAll('option');
      options.forEach(function(option) {
        option.disabled = false;
      });
    });
  }

  enableSoldOutOptions();
  setTimeout(enableSoldOutOptions, 1000); // 念のため1秒後にも実行
})();